import React, { useState } from "react";
import IserbaAvatarViewer from "../../../../onboarding/iserba/IserbaAvatarViewer";
import IserbaGame3ClickPuzzle from "./whileDriving/Game3ClickPuzzle";
import Game3ValidationScreen from "./whileDriving/Game3ValidationScreen";
import CumulatedScore from "components/quiz/CumulatedScore";

const IserbaGame3Wrapper = ({
	quiz,
	question,
	onAnswer,
	quizResults,
	setQuizResults,
	handleNext,
}) => {
	const [step, setStep] = useState("puzzle"); // 'puzzle' -> 'evaluation'
	const [isPuzzleCorrect, setIsPuzzleCorrect] = useState({
		scene_1_correct: false,
		scene_1_errors: [],
	});

	const storedPlayer = localStorage.getItem("player");
	let player = storedPlayer ? JSON.parse(storedPlayer) : null;

	const handlePuzzle1Completion = (result) => {
		setIsPuzzleCorrect((prev) => ({
			...prev,
			...result,
		}));
		setStep("evaluation");
	};

	const handleRetry = () => {
		setQuizResults((prev) => ({
			...prev,
			score: prev.score - 1,
		}));
		setStep("puzzle");
	};

	const onSubmitAndNext = () => {
		onAnswer({ value: isPuzzleCorrect });
		handleNext();
	};

	const getHeaderText = () => {
		switch (step) {
			case "puzzle":
				return "Répondez correctement aux questions.";
			case "evaluation":
				if (isPuzzleCorrect.scene_1_correct) return "Félicitations !";
				return "Oops! Un accident s'est produit. Essayez encore";
			default:
				return "Répondez correctement aux questions.";
		}
	};

	return (
		<div className="relative flex flex-col items-center h-full mt-4">
			<div className="px-4 flex flex-1 justify-between items-end gap-2">
				<div className="flex flex-col text-white">
					<IserbaAvatarViewer player={player} />
					<h3 className="text-sm text-gray-700 py-2 px-4 shadow-md mb-2 bg-white rounded-full">
						{getHeaderText()}
					</h3>
				</div>

				{quiz?.config?.show_cumulated_score && (
					<div className="flex py-2 px-1">
						<CumulatedScore quizId={quiz.id} quizResults={quizResults} />
					</div>
				)}
			</div>

			<div className="flex-[3] flex justify-center items-start">
				{step === "puzzle" && (
					<IserbaGame3ClickPuzzle
						question={question}
						onAnswer={handlePuzzle1Completion}
					/>
				)}

				{step === "evaluation" && (
					<Game3ValidationScreen
						isPuzzleCorrect={isPuzzleCorrect}
						onRetry={handleRetry}
						onNext={onSubmitAndNext}
					/>
				)}
			</div>
		</div>
	);
};

export default IserbaGame3Wrapper;
